import './radiologist.css';
import { allFindings } from '../findings-overlay';
import { refreshReportLabels, renderFinding } from '../messages';
import { COMPOSE_TEXT, showCompose } from './compose';
import { contextOnOpen, CONTEXT_TEXT, showPatientContext } from './patient-context';
import { PREPARE_TEXT, prepareStudy } from './prepare';
import { RECIST_TEXT, showRecist } from './recist';
import { CHECK_TEXT, showReportCheck } from './report-check';
import { showPatientSummary, SUMMARY_TEXT } from './patient-summary';
import type { ToolKey } from './shapes';
import { loadSwitches, toolOn } from './switches';
import type { RadiologistDeps } from './ui';
import { conversationStudy } from '../context';

export { showFollowup } from './followup';
export { markFindingKeyImage } from './key-image';
export { toolOn } from './switches';

/**
 * The radiologist tools of the Asistente Guru (ris docs/viewer-ai-tools-contract.md): read which
 * tools the org switched on, then add the switched-on ones to the tools row. "Enviar al informe"
 * (send_to_report) has no button of its own: it changes what "Copiar al informe" does everywhere;
 * "Seguimiento" and "Imagen clave" sit on reviewed findings (messages.ts), and "Contexto del
 * paciente" also opens by itself the first time the Asistente shows a study.
 */

const BUTTONS: Array<[key: ToolKey, label: string, run: (deps: RadiologistDeps) => unknown]> = [
  ['patient_context', CONTEXT_TEXT.tool, (deps) => showPatientContext(deps, conversationStudy(deps.shell))],
  ['prepare_study', PREPARE_TEXT.tool, prepareStudy],
  ['report_compose', COMPOSE_TEXT.tool, showCompose],
  ['report_check', CHECK_TEXT.tool, showReportCheck],
  ['recist', RECIST_TEXT.tool, showRecist],
  ['patient_summary', SUMMARY_TEXT.tool, showPatientSummary],
];

/** Findings drawn before the switches arrived get their Seguimiento / Imagen clave buttons now. */
function refreshFindings(deps: RadiologistDeps): void {
  for (const finding of allFindings()) deps.panel.replaceFinding(finding, (f) => renderFinding(f, deps.handlers));
}

export async function installRadiologistTools(deps: RadiologistDeps): Promise<void> {
  const switches = await loadSwitches(deps.api);
  if (!switches.enabled) return;
  for (const [key, label, run] of BUTTONS) {
    if (!toolOn(key)) continue;
    const b = deps.panel.addToolButton(label, () => void run(deps));
    b.dataset.tool = key;
  }
  refreshFindings(deps);
  refreshReportLabels(deps.panel.root);
  if (toolOn('patient_context')) deps.panel.onConversation((study) => contextOnOpen(deps, study));
}
